import React from 'react';
import { Sun, Battery, BarChart as ChartBar, Check, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SolarPlan: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-wenergie-blue/10 via-sky-50 to-wenergie-orange/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Get More From Your Solar. Effortlessly.
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              Turn every unit you generate into value — with zero hassle.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center justify-center px-8 py-3 bg-wenergie-blue text-white rounded-full font-medium hover:bg-wenergie-blue/90 transition duration-300 shadow-lg"
            >
              Join the Network
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            🌞 Make Your Solar Work Smarter with Wenergie
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <ChartBar className="h-12 w-12 text-wenergie-blue mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Track & Maximise Uptime</h3>
              <p className="text-gray-600">
                Monitor your system performance in real-time, spot issues early, and ensure your panels keep delivering at their best.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <Sun className="h-12 w-12 text-wenergie-orange mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Earn Rewards Automatically</h3>
              <p className="text-gray-600">
                Get rewarded for every clean unit you generate — by powering nearby users when they need it most.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <Battery className="h-12 w-12 text-wenergie-blue mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Optimise with Battery Integration</h3>
              <p className="text-gray-600">
                Got storage? We help you time your battery use for maximum impact — and greater rewards.
              </p>
            </div>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Works with All Major Brands</h3>
              <p className="text-gray-600 mb-6">
                No new hardware needed. Wenergie is fully compatible with leading solar and battery systems.
              </p>
              <div className="flex items-center text-wenergie-blue">
                <Check className="h-5 w-5 mr-2" />
                <span>Compatible with all major inverters</span>
              </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Set Up in Under a Minute</h3>
              <p className="text-gray-600 mb-6">
                Seamless online enrollment. No paperwork, no visits — just connect and start earning.
              </p>
              <div className="flex items-center text-wenergie-blue">
                <Check className="h-5 w-5 mr-2" />
                <span>Instant digital setup</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default SolarPlan;